var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-content"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("页面不存在")])])])}]

export { render, staticRenderFns }